export const movePermission = ({ data, cardId }) => {
  const cardIndex = data.findIndex((item) => item.card.id === cardId);

  return {
    canMoveLeft: cardIndex > 0,
    canMoveRight: cardIndex >= 0 && cardIndex < data.length - 1,
  };
};
